<div class="ag-theme-quartz" style="width: 100%; height: 75vh">
  <ag-grid-angular class="h-full" [gridOptions]="gridOptions"></ag-grid-angular>
</div>
